<template>
  <el-select
    v-model="computedValue"
    placeholder="请选择（单选）"
    clearable
    style="width: 350px"
    :disabled="!editable"
  >
    <el-option
      v-for="item in config.options"
      :key="item.baseQuestionOptionId"
      :label="item.baseQuestionOptionName"
      :value="String(item.baseQuestionOptionId)"
    >
    </el-option>
  </el-select>
</template>

<script>
import CompMix from "../../mixins/comp-mix";
export default {
  mixins: [CompMix],
};
</script>

<style lang="scss" scoped></style>
